import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo, useRef, } from 'react';
import MuiBadge from '@material-ui/core/Badge';
import { combineClasses, logInDev, styled, useChange, useForkRef, useThemeProps, } from '../../foundation';
import { BadgeStyle } from './styles';
import { RcBadgeClasses, useRoundBadgeOffset } from './utils';
import { DotBadgeContext, DotBadge } from './DotBadge';
var _RcBadge = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcBadge' });
    var classesProp = props.classes, children = props.children, overlap = props.overlap, color = props.color, variant = props.variant, textColor = props.textColor, anchorOrigin = props.anchorOrigin, borderColor = props.borderColor, component = props.component, dotComponent = props.dotComponent, dotProps = props.dotProps, invisible = props.invisible, badgeContent = props.badgeContent, _a = props.showZero, showZero = _a === void 0 ? false : _a, rest = __rest(props, ["classes", "children", "overlap", "color", "variant", "textColor", "anchorOrigin", "borderColor", "component", "dotComponent", "dotProps", "invisible", "badgeContent", "showZero"]);
    // * should never change overlap
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useChange(function (prev) {
            if (!prev)
                return;
            logInDev({
                component: 'RcBadge',
                message: 'Should not change `overlap` prop after component render',
                level: 'error',
            });
        }, function () { return overlap; });
    }
    var innerRef = useRef(null);
    var badgeRef = useForkRef(innerRef, ref);
    var isRound = overlap === 'round';
    var isDot = variant === 'dot';
    var notPassOverlapToMui = overlap !== 'none' && !isRound;
    // overlap will never change in production mode
    if (isRound) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useRoundBadgeOffset(innerRef);
    }
    var classes = useMemo(function () { return combineClasses(RcBadgeClasses, classesProp); }, [classesProp]);
    var renderBadge = function (customComponent) {
        if (customComponent === void 0) { customComponent = component; }
        return (React.createElement(MuiBadge, __assign({}, rest, { variant: variant, invisible: invisible, badgeContent: badgeContent, showZero: showZero, anchorOrigin: anchorOrigin, component: customComponent, 
            // TODO: that as any for ts v3.8 still not support pick variable out of if check
            overlap: notPassOverlapToMui ? overlap : undefined, ref: badgeRef, classes: classes }), children));
    };
    if (isDot) {
        return (React.createElement(DotBadgeContext.Provider, { value: {
                anchorOrigin: anchorOrigin,
                dotComponent: dotComponent,
                dotProps: dotProps,
                invisible: invisible,
                overlap: overlap,
                children: children,
                badgeContent: badgeContent,
                showZero: showZero,
            } }, renderBadge(DotBadge)));
    }
    return renderBadge(component);
});
var RcBadge = styled(_RcBadge)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), BadgeStyle);
RcBadge.defaultProps = {
    color: 'umi.mentioned',
    textColor: 'umi.text',
    overlap: 'rectangular',
    anchorOrigin: {
        horizontal: 'right',
        vertical: 'top',
    },
};
RcBadge.displayName = 'RcBadge';
export { RcBadge };
var templateObject_1;
